module.exports = __webpack_public_path__ + "static/media/D9.2df28e38.png";